import { render } from "./GeneralSection.vue?vue&type=template&id=3706eb59"
import script from "./GeneralSection.vue?vue&type=script&lang=js"
export * from "./GeneralSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__